import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateLieu, type LieuDto } from "../api/lieuxApi";
import { queryKeys } from "../lib/queryKeys";

export function useUpdateLieu(id: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (dto: LieuDto) => updateLieu(id, dto),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: queryKeys.lieux.all });
      qc.invalidateQueries({ queryKey: queryKeys.lieux.detail(id) });
      qc.invalidateQueries({ queryKey: queryKeys.artists.all });
    },
  });
}
